import React from 'react';

const ConfirmationModal = ({ 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass = 'btn-danger'
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10001,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        animation: 'slideIn 0.3s ease-out'
      }}>
        <h2 style={{ 
          marginTop: 0, 
          marginBottom: '1rem', 
          color: '#374151', 
          fontSize: '1.5rem' 
        }}>
          {title}
        </h2>
        <p style={{ 
          marginBottom: '1.5rem', 
          color: '#6b7280', 
          lineHeight: '1.6',
          whiteSpace: 'pre-line'
        }}>
          {message}
        </p>
        <div style={{ 
          display: 'flex', 
          gap: '0.75rem', 
          justifyContent: 'flex-end' 
        }}>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            style={{
              padding: '0.625rem 1.25rem',
              fontSize: '0.9rem'
            }}
          >
            {cancelText}
          </button>
          <button
            className={`btn ${confirmButtonClass}`}
            onClick={onConfirm}
            style={{
              padding: '0.625rem 1.25rem',
              fontSize: '0.9rem'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
